module.exports = __webpack_public_path__ + "img/pen-field.88ea4844.svg";